import React from 'react'


import { HiOutlineClipboardDocument } from 'react-icons/hi2'
import { Description } from '.'

export default function EmptyContainer({
    classes = '',
    icon = <HiOutlineClipboardDocument size={90} color="currentColor" />,
    text = 'No Quiz Found',
    iconColor = "white",
    textClasses = '',
}) {
    return (
        <div className={`w-100 my-5 d-flex flex-column align-items-center justify-content-center ${classes}`}>
            <span className={`text-${iconColor}`}>{icon}</span>
            <Description
                text={text}
                size='4'
                classes={`mt-3 ${textClasses}`}
            />
        </div>
    )
}
